import { render, staticRenderFns } from "./covMedCertFile_upload.vue?vue&type=template&id=936b203c&scoped=true&"
import script from "./covMedCertFile_upload.vue?vue&type=script&lang=js&"
export * from "./covMedCertFile_upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936b203c",
  null
  
)

export default component.exports